"use client";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAuth } from "@/state/globalStore";
import { type PutSituationRequest } from "@/generated/fastapi";
import { putSituation } from "../api/putSituation";
import { situationsKeys } from "../queries/keys";

export default function useUpdateSituationMutation() {
  const queryClient = useQueryClient();
  const { accessToken } = useAuth();

  return useMutation({
    mutationFn: (request: PutSituationRequest) => putSituation(accessToken, request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: situationsKeys.all });
    },
  });
}
